/*eslint no-script-url: 0 */
import React, { Component } from "react";
import MatSizeSelection from '../Components/Mats/MatSizeSelection';
import MatSelection from '../Components/Mats/MatSelection';
import {Loader} from '../Helpers/Helpers';
import Constants from '../Config/Config';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/mats.json';

class Mats extends Component {

	constructor(props) {
        super(props);
        this.state = {
            error: null
        }
    }

    fetchMats = () => {
        var self = this;
        fetch(URL)
        .then(response => {
            if (!response.ok) {
                throw Error('Network request failed.')
            }
            return response;
        })
        .then(data => data.json())
        .then(data => {
            self.dispatchMatsData(data);
            data.filter( ( mat ) =>
                'Antique Blue VW2108' === mat['title']['rendered']
            ).map( ( mat ) =>
                self.dispatchSelectMat(mat)
            )
        }, (ex) => {
            this.fetchMats();
            self.setState({ error: ex.message });
        })
    }

    dispatchMatsData(MatsData) {
        const data = MatsData;
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                mats: data,
                matsLoaded: true,
                selectedTopMat: data[0]
            }
        })
    }

    dispatchSelectMat(MatsData) {
        const data = MatsData;
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                selectedTopMat: data,
                matsUpdated: this.props.matsUpdated === 1 ? 0 : 1
            }
        })
    }

    componentDidMount() {
        this.fetchMats();
    }

	render() {
	    return (
			<div className="row">
				<div className="col-sm-12 mats-items">
					<div className="card h-100">
						<div className="card-body">
							{this.props.matsLoaded === true ?
								<div className="row">
									<MatSizeSelection
										{...this.props} />
									<MatSelection
										{...this.props}
										error={this.state.error} />
								</div> :
								<Loader/>
							}
						</div>
					</div>
				</div>
			</div>
	    );
  	}
}

export default Mats;